import styled from 'styled-components';
export const Container = styled.div `
  flex: 1;
`;
export const DataWrapper = styled.div `
  max-height: 310px;
  overflow-y: auto;
`;
export const GiftCardCodeWrapper = styled.div `
  display: flex;
  gap: var(--space-200);
  align-items: center;
`;
export const GiftCardBalanceWrapper = styled.div `
  color: var(--text-secondary);
  font-size: var(--font-size-300);
  line-height: var(--font-line-height-300);
`;
export const Footer = styled.div `
  margin-top: var(--space-400);
  display: flex;
  gap: var(--space-300);
`;
